import { useDispatch, useSelector } from "react-redux";
import { useRef, useState } from "react";

import Button from "../../../../../common/Button";
import { updateProcodocsUploadedDocument } from "../../../../../../lib/fetchApi";
import { notificationActions } from "../../../../../../store/notifications";
import { caseActions } from "../../../../../../store/case";
import BodySimpleModalV3 from "../../../../../common/modal/BodySimpleModalV3";


export default function UpdateDocument({item}) {
    const inputRef = useRef(null)
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const onFileDrop = (e) => {
        if (e.target.files.length > 0) {

            let filesArray = Array.from(e.target.files).map(item => {
                
                return {
                    id: Math.random(),
                    file: item.name,
                    file_to_upload: item,
                }
            })

            if(filesArray && filesArray.length) {

                let file = filesArray[0]
                let formData = new FormData();

                formData.append("file", file.file_to_upload);

                let reqBody = formData      

                saveFileHandler(reqBody)
            }
        }

    }

    async function saveFileHandler(req) {
        setLoading(true)
        try {
            const upload = await updateProcodocsUploadedDocument(userToken, activeCase.case.id, item?.id ,req, dispatch)

            if (upload && upload.errorMessage) {
                dispatch(notificationActions.setError(upload))             
            } else {
                // /success 
                dispatch(caseActions.updateItemInProcoDocuments(upload))
            }
        } finally {
            setLoading(false)
        }
    }    

    const openUploadHandler = () => {
        inputRef.current.click()
    }

    return <>
        <input ref={inputRef} type="file" value="" onChange={onFileDrop} name="update_uploaded_document" id="update_uploaded_document" style={{display: 'none'}}/>
        {/* <Button btnStyle={'btn_text'} click={openUploadHandler} isLoading={loading} loaderType={'dark'}>Update</Button> */}
        <BodySimpleModalV3 message={'Update document'}>
            <Button btnStyle={'btn_small_icon'} click={openUploadHandler} isLoading={loading} loaderType={'dark'}>
                <i className="ti ti-upload"></i>
                {/* Update */}
            </Button>
        </BodySimpleModalV3>
    </>
}